module.exports = [
  {name: "Getting Started", file: "GettingStarted.md"},
  {name: "FAQ", file: "FAQ.md"},
  {
    name: "Changelog",
    slug: "Changelog.md",
    remote: "https://raw.githubusercontent.com/qeled/discordie/master/changelog.md"
  },
];


// WEBPACK FOOTER //
// ./src/data/pages.js